import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.js";
import Vue3PersianDatetimePicker from "vue3-persian-datetime-picker";
import "bootstrap";
// import Paginate from 'vuejs-paginate';
axios.defaults.baseURL = "https://api.poct.nikted.com/api/v1";
// axios.defaults.baseURL = "http://127.0.0.1:8000/api/v1";

createApp(App).component("DatePicker", Vue3PersianDatetimePicker);
// createApp(App).component("paginate",Paginate)
createApp(App).use(Vue3PersianDatetimePicker, {
  name: "CustomDatePicker",
  props: {
    format: "YYYY-MM-DD",
    displayFormat: "jYYYY-jMM-jDD",
    editable: false,
    inputClass: "form-control my-custom-class-name",
    placeholder: "لطفا تاریخ را وارد کنید",
    altFormat: "YYYY-MM-DD HH:mm",
    color: "#00acc1",
    autoSubmit: false,
    //...
    //... And whatever you want to set as default.
    //...
  },
});
createApp(App).use(store).use(router).mount("#app");
